import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {IpdModalComponent} from '../../ipd/ipd-modal/ipd-modal.component';
import {IpdTransactionComponent} from '../../ipd/ipd-transaction/ipd-transaction.component';
import { IpdPaymentModalComponent } from '../../ipd/ipd-payment-modal/ipd-payment-modal.component';
import {formatDate} from '@angular/common';
import * as XLSX from 'xlsx';
declare var $: any;
import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { UserService } from 'src/app/_service/user.service';
import { PatientJourneyDetailsComponent } from '../patient-journey-details/patient-journey-details.component';
@Component({
  selector: 'app-ipds',
  templateUrl: './ipds.component.html',
  styleUrls: ['./ipds.component.css']
})
export class IpdsComponent implements OnInit {
    perpage:number=25;ipds:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';userId:string;
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;bds=[];loaded:boolean=false;circles=[];circle='';payment_mode='';lead_source='';
    search:string;doctor:string;hospital:string;bd:string;start_date:string='';end_date:string='';treatments=[];
    submitted:boolean=false;doctors=[];hospitals=[];ipdDetail:any={};ipdCopy:string;txt:string='Copy';sc3Url:string='';doctorFilter:boolean=true;hospitalFilter:boolean=true;bds_copy=[];doctors_copy=[];hospitals_copy=[];treatments_copy=[];status='';feedbackStatus='';IpdID:any='';ipdHistoryDetail = [];billedloading:boolean=true;billedloaded:boolean=false;is_specialCase:string;lead_category_filter='';treatCategory=[];copyIPDData:boolean= false;leadId:number;pageType:any;gender:string;lead_sources=[];
    pre_op_loading:boolean=false; post_op_loading:boolean=false; isCMAccess:string;is_presales_access:string;
    click_to_call_loading:boolean=false;response_call_id='';progression_msg='';end_to_call_btn_disable=false;
    callDeatils=[];assigned_to_submitted:boolean=false;updatedPxAssignedToLeadId:string;notupdatedPxAssignedToLeadId:string;
    feedBackUser=[];
    followup_start_date:string='';followup_end_date:string='';is_doctor_access:string;
    md_source:number=34;mdSpokData=[];mdSpokData_copy=[];mdspok=''
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild('followupDateRangeStart', {static: false}) followupDateRangeStart: ElementRef;
    @ViewChild('followupDateRangeEnd', {static: false}) followupDateRangeEnd: ElementRef;
    @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('pdfTable') pdfTable: ElementRef;
    @ViewChild('csvUploadPxAssignedTeam', {static: false}) csvUploadPxAssignedTeam: ElementRef;
    @ViewChild('csvUploadShares', {static: false}) csvUploadShares: ElementRef;
    constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,private activatedRoute: ActivatedRoute,public miscapi:MiscService,private router : Router,private userapi:UserService) {
        //console.log(this.router.url);
        if(this.router.url.includes('ipds')){
            this.pageType = 1;
        }else{
            this.pageType = 2;
        }
        this.activatedRoute.params.subscribe(params => {
            console.log(params);
            if (params['doctor_id']) {
                this.doctor = params['doctor_id'];
                this.doctorFilter=false;
            }else if (params['hospital_id']) {
                this.hospital = params['hospital_id'];
                this.hospitalFilter=false;
            }
        });
        
    }

    sharePaymentLink(lead_id,type){
        const dialogRef = this.dialog.open(IpdPaymentModalComponent, {
            width: '45%',
            height: '50%',
            data:{lead_id:lead_id,type:type}
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    

    public downloadAsPDF() {
        const doc = new jsPDF();

        const pdfTable = this.pdfTable.nativeElement;

        var html = htmlToPdfmake(pdfTable.innerHTML);

        const documentDefinition = { content: html };
        pdfMake.createPdf(documentDefinition).download('IPD_'+this.IpdID+'.pdf');

    }

    resetFilters(){
        this.clearDate();
        this.search = ''; this.bd = '';this.circle = '';this.doctor = '';this.hospital = '';this.treatment = '';this.status = '';this.lead_source = '';this.payment_mode = '';this.feedbackStatus = '';this.lead_category_filter = '';this.is_specialCase = '';this.gender = '';this.mdspok='';
        this.clearFollowupDate();
       
       
        this.loadIpds(0,25);
    }
    
    getRefferalType(type){
        let status = 'NA';
        switch(type)
        {
            case 1:
            status = 'Doctor Refferal';
            break;
            case 2:
            status = 'Employee Refferal';
            break;
            case 3:
            status = 'Others Refferal';
            break;
            case 4:
            status = 'Patient Refferal';
            break;
            case 5:
            status = 'PX Refferal';
            break;
            case 6:
            status = 'Diagnostic Refferal';
            break;
            case 7:
            status = 'Lab Refferal';
            break;
            case 8:
            status = 'Phlebotomist Refferal';
            break;
            case 9:
            status = 'City Team';
            break;
            
        }
        return status;
    }


    ngOnInit(): void
    {
        this.getbds();this.getcircle();this.getLeadSources();
        this.getTreatment();this.getTreatmentCategory();
        this.getDoctor();this.getHospital();
        this.sharedapi.getRole()
        this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.userId = localStorage.getItem('loginuserId');
        this.sc3Url= localStorage.getItem('s3url');
        this.isCMAccess = localStorage.getItem('CMAccess');
        this.is_doctor_access = localStorage.getItem('is_doctor_access');
        this.is_presales_access = localStorage.getItem('is_preSales');
        if(this.myrole=='13'){
            this.lead_source='24';
        }
        if(this.myrole == '1' || (this.myrole=='4' && this.isCMAccess=='1')) this.getFeedBackUser();
        this.getMdSpok(this.md_source);
        if(this.myrole=='16'){
            this.router.navigateByUrl('dashboard');
        }
    }

    sendPreOperativeDeatils(){
        this.pre_op_loading = true;
        this.leadapi.sendPreOperativeMessage().subscribe((data:any) => {
            if(data.status)
            {
                this.pre_op_loading=false;
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.pre_op_loading=false;
            this.sharedapi.checkError(error);
        });

    }

    sendPostOperativeDeatils(){
        this.post_op_loading = true;
        this.leadapi.sendPostOperativeMessage().subscribe((data:any) => {
            if(data.status)
            {
                this.post_op_loading=false;
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.post_op_loading=false;
            this.sharedapi.checkError(error);
        });

    }


    async getLeadSources()
    {
        this.leadapi.getLeadSources().subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    setSearchValue(type){
        if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
            this.bds= this.bds_copy;
        }else if(type=='doctor'){
            $("#doctorSearch").val('');
            $("#doctorSearch").focus();
            this.doctors= this.doctors_copy;
        }else if(type=='hospital'){
            $("#hospitalSearch").val('');
            $("#hospitalSearch").focus();
            this.hospitals= this.hospitals_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }else if(type=='mdspok'){
            $("#mdspokSearch").val('');
            $("#mdspokSearch").focus();
            this.mdSpokData= this.mdSpokData_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if(type == 'lead_owner'){
             this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'doctor'){
            this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
        }else if(type == 'hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else if(type == 'mdspok'){
            this.mdSpokData = this.sharedapi.searchData(searchtText, this.mdSpokData_copy, "name");
        }
    }

    ngAfterViewInit() {
         this.loadIpds(0,this.perpage);
    }

    async loadIpds(pageIndex,perpage)
    {
        this.ipds = [];
        this.paginator.pageIndex = pageIndex;
        this.paginatorBottom.pageIndex = pageIndex;
        this.pageIndex = pageIndex;
        let qString = 'hospital='+this.hospital+'&doctor='+this.doctor+'&search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&payment_mode='+this.payment_mode+'&bd='+this.bd+'&date_range='+this.start_date+'-'+this.end_date+'&status='+this.status+'&feedbackStatus='+this.feedbackStatus+'&is_specialCase='+this.is_specialCase+'&lead_source='+this.lead_source+'&lead_category_filter='+this.lead_category_filter+'&pagetype='+this.pageType+'&gender='+this.gender+'&mdspok='+this.mdspok+'&followup_date_range='+this.followup_start_date+'-'+this.followup_end_date;
        this.loading = true;this.loaded = false;
        this.leadapi.getIpds(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.ipds = data.data;
            }else{
                this.ipds = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    showDuplicateModal(ipdId,leadid){
        this.leadId = leadid;
        this.IpdID = ipdId; 
        $('#duplicateModal').modal();
    }

    hideduplicateModal()
    {
        $('#duplicateModal').modal('hide');
    }

    copyLeadIpd(){
        this.copyIPDData=true;
        this.leadapi.createSecondDiseaseIpd(this.leadId,this.IpdID).subscribe((data:any) => {
            if(data.status)
            {
                this.copyIPDData=false;
                $('#duplicateModal').modal('hide');
                this.loadIpds(0,this.perpage);
            }
        }, error => {
            this.copyIPDData=false;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadIpds(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadIpds(event.pageIndex,event.pageSize);
    }

    async getbds()
    {
        await this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getDoctor()
    {
        await this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getHospital()
    {
        await this.leadapi.gethospitals().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            //this.loadIpds(0,this.perpage);
        }
    }

    followupDateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.followup_start_date = date1.value;
            this.followup_end_date = date2.value;
            //this.loadIpds(0,this.perpage);
        }
    }

    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        //this.loadIpds(0,this.perpage);
    }

    clearFollowupDate()
    {
        this.followupDateRangeStart.nativeElement.value = "";
        this.followupDateRangeEnd.nativeElement.value = "";
        this.followup_start_date = '';
        this.followup_end_date = '';
        //this.loadIpds(0,this.perpage);
    }

    openIpdTransaction(lead_id,ipd_id,treatment_id)
    {
        const dialogRef = this.dialog.open(IpdTransactionComponent, {
            width: '100%',
            height: '90%',
            data:{lead_id:lead_id,ipd_id:ipd_id,treatment_id:treatment_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openIpdDialog(lead_id)
    {
        const dialogRef = this.dialog.open(IpdModalComponent, {
            width: '100%',
            height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    async markStatus(ipd_id,status)
    {
        let msg = 'Complete';
        if(status==3)
        msg = 'Cancel';
        if(confirm("Do you want to "+msg+" this IPD?"))
        {
            await this.leadapi.changeStatusIpd(ipd_id,status).subscribe((data:any) => {
            this.sharedapi.presentToast(data.msg);
            this.loadIpds(this.pageIndex,this.perpage);
        }, error => {
            this.sharedapi.checkError(error);
        });
        }
    }

    hideModal(val)
    {
        if(val=='1'){
            $('#myModal').modal('hide');
        }else{
            $('#BilledModal').modal('hide');
        }

    }

    async viewIpd(ipd_id)
    {
        this.IpdID= ipd_id;
        this.txt='Copy';
        $('#myModal').modal();
        await this.leadapi.viewIpdDetails(ipd_id).subscribe((data:any) => {
            if(data.status)
            {
                this.ipdDetail = data.data;
                let surgery_date = formatDate(data.data.surgery_date*1000, 'dd MMM, yyyy', 'en-US');
                let arrival_time = formatDate(data.data.arrival_time*1000, 'hh:mm aa', 'en-US');
                let treatment_time = formatDate(data.data.treatment_time*1000, 'hh:mm aa', 'en-US');
                let payment_mode = this.getPaymentType(data.data.payment_mode);
                let room_type = this.getRoomCategory(data.data.room);
                this.ipdCopy = "*Patient Name :* "+data.data.patient+" \n\n*Medical Counsellor :* "+data.data.bd_name+"\n\n*Doctor Name :* "+data.data.doctor_name+"\n\n\
*Treatment :* "+data.data.treatment_name+"\n\n*Hospital Name :* "+data.data.hospital_name+"\n\n *Hospital Room Category :* "+room_type+ "\n\n*Address :* "+data.data.address+"\n\n\
*Location :* "+data.data.location+"\n\n*Surgery Date :* "+surgery_date+"\n\n*Appointment Time at the center :* "+arrival_time+"\n\n*Fee :* "+data.data.billed_amt+"\n\n\
*Treatment Time :* "+treatment_time+"\n\n*Test :* "+data.data.test+"\n\n*Attendant :* "+data.data.attendant+"\n\n*Payment Type :* "+payment_mode+"\n\n*Regards Glamyo Health*";
            }else{
                this.ipdDetail = {};
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async viewBilledHistory(ipd_id)
    {
        this.ipdHistoryDetail=[];
        this.IpdID= ipd_id;
        $('#BilledModal').modal();
        this.billedloading = true;this.billedloaded = false;
        await this.leadapi.viewBilledAmountDetails(ipd_id).subscribe((data:any) => {
            if(data.status)
            {
               this.billedloading = false;this.billedloaded = true;
               this.ipdHistoryDetail=data.data;

            }else{
                this.billedloading = false;this.billedloaded = true;
                this.ipdHistoryDetail = [];

            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    getPaymentType(payment_type)
    {
        return this.sharedapi.getPaymentType(payment_type);
    }

    getRoomCategory(room)
    {
        return this.sharedapi.getRoomCategory(room);
    }

    exportIpdList()
    {
        if(this.ipds.length>0)
        {
            let data = [];
            let titles = ['Ipd Id','Lead Id','Lead Status','Patient Name','Appointment Id','Glamyo Partner Id','Glamyo Appointment Id','Patient Age','Patient Gender','Lead Circle','IPD Circle','Lead Owner','Employee Id','Treatment','Treatment Catergory','Mole/Lipoma Count','Doctor','Hospital','Room Catergory','Room Capping','Payment Mode','EMI Vendor Name','Lead Date','Surgery Date','Arrival Time','Treatment Time','On Admission','On Discharge','Billed Amount','Status','Created Date','Aadhar','Discharge Summary','Bill Copy','Insurance','Pre-Auth','Pre-Approval','Final Approval','Settlement Letter','Lead Source','Lead Sub-Source','Campaign Name','Keywords','AD Group Id','Match Type','Form Lead Source'];
            if(this.myrole=="5" || this.myrole=='1' || this.myrole=="9" || this.myrole=='15')
            {
                titles.push('TPA');
                titles.push('Insurance Company');
                titles.push('Policy Number');
                titles.push('Corporate Name');
                titles.push('Copay');
                titles.push('Remarks');
            }
            if(this.myrole=="1")
            {
                titles.push('Patient Mobile');
            }
            data.push(titles);
            for(let key in this.ipds)
            {
                let aadhar= 'Not Uploaded';
                if(this.ipds[key].aadhar_copy.length)
                aadhar= 'Uploaded';
                let discharge_summary= 'Not Uploaded';
                if(this.ipds[key].discharge_summary.length)
                discharge_summary= 'Uploaded';

                let bill_copy= 'Not Uploaded';
                if(this.ipds[key].bill_copy.length)
                bill_copy= 'Uploaded';

                let insurances_copy= 'Not Uploaded';
                if(this.ipds[key].insurance_copy.length)
                insurances_copy= 'Uploaded';

                let pre_auth_copy= 'Not Uploaded';
                if(this.ipds[key].pre_auth_copy.length)
                pre_auth_copy= 'Uploaded';

                let pre_approval_copy= 'Not Uploaded';
                if(this.ipds[key].pre_approval_copy.length)
                pre_approval_copy= 'Uploaded';

                let final_approval_copy= 'Not Uploaded';
                if(this.ipds[key].final_approval_copy.length)
                final_approval_copy= 'Uploaded';

                let SettlementDoc_copy= 'Not Uploaded';
                if(this.ipds[key].SettlementDoc_copy.length)
                SettlementDoc_copy= 'Uploaded';
                let glamyoPatientId = 'GHIPD'+this.ipds[key].id;

                let leadSubSource = '';
                if(this.ipds[key].referral_type==1){
                    leadSubSource = 'Doctor Refferal'; 
                }else if(this.ipds[key].referral_type==2){
                    leadSubSource = 'Employee Refferal'; 
                }else if(this.ipds[key].referral_type==3){
                    leadSubSource = 'Others Refferal'; 
                }else if(this.ipds[key].referral_type==4){
                    leadSubSource = 'Patient Refferal'; 
                }else if(this.ipds[key].referral_type==5){
                    leadSubSource = 'PX Refferal'; 
                }else if(this.ipds[key].referral_type==6){
                    leadSubSource = 'Diagnostic Refferal'; 
                }else if(this.ipds[key].referral_type==7){
                    leadSubSource = 'Lab Refferal'; 
                }else if(this.ipds[key].referral_type==8){
                    leadSubSource = 'Phlebotomist Refferal'; 
                }else if(this.ipds[key].referral_type==9){
                    leadSubSource = 'City Team Refferal'; 
                }

                let exdata = [this.ipds[key].id,this.ipds[key].lead_id,this.ipds[key].leadStatus,this.ipds[key].patient,this.ipds[key].patient_id,this.ipds[key].glamyo_patient_id,glamyoPatientId,this.ipds[key].patient_age,this.ipds[key].gender,this.ipds[key].lead_circle_name,this.ipds[key].circle_name,this.ipds[key].bd_name,this.ipds[key].useremployee_id,this.ipds[key].treatment_name,this.ipds[key].treatment_categoriesName,this.ipds[key].lmcCount,this.ipds[key].doctor_name,this.ipds[key].hospital_name,this.getRoomCategory(this.ipds[key].room),this.ipds[key].room_rent,this.getPaymentType(this.ipds[key].payment_mode),this.ipds[key].emi_vendor_name,
                formatDate(this.ipds[key].leadCreatedTime*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),
                            formatDate(this.ipds[key].surgery_date*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),formatDate(this.ipds[key].arrival_time*1000, 'hh:mm aa', 'en-US'),formatDate(this.ipds[key].treatment_time*1000, 'hh:mm aa', 'en-US'),this.ipds[key].admission_amt,this.ipds[key].discharge_amt,this.ipds[key].billed_amt,this.sharedapi.getStatus(this.ipds[key].status),formatDate(this.ipds[key].created_at*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),
                            aadhar,discharge_summary,bill_copy,insurances_copy,pre_auth_copy,pre_approval_copy,final_approval_copy,SettlementDoc_copy, this.ipds[key].source_name,leadSubSource,
                            this.ipds[key].campaign_name,
                    this.ipds[key].keywords,
                    this.ipds[key].utm_agid,
                    this.ipds[key].matchtype,
                    this.ipds[key].zoho_lead_source
                        ];
                if(this.myrole=="5" || this.myrole=="1" || this.myrole=="9" || this.myrole=="15")
                {
                    exdata.push(this.ipds[key].tpa);
                    exdata.push(this.ipds[key].insurance_company);
                    exdata.push(this.ipds[key].policy_number);
                    exdata.push(this.ipds[key].corporate);
                    exdata.push(this.ipds[key].copay);
                    exdata.push(this.ipds[key].insurance_description);
                }
                if(this.myrole=="1")
                {
                    exdata.push(this.ipds[key].phone);
                }
                data.push(exdata)
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'ipd_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('IPD not found!');
        }
    }

    markasElective(ipd_id)
    {
        let msg = 'Complete';
        msg = 'Cancel';
        if(confirm("Do you want to mark this IPD as elective ?"))
        {
            this.leadapi.markAsElective(ipd_id).subscribe((data:any) => {
            this.sharedapi.presentToast(data.msg);
            this.loadIpds(this.pageIndex,this.perpage);
        }, error => {
            this.sharedapi.checkError(error);
        });
        }
    }


    click_to_call_function(lead_id)
    {
        this.click_to_call_loading = true;
        let lead_id_arr = {'lead_id': lead_id};
        this.leadapi.OpdIpdClickTOCall(lead_id_arr).subscribe((data:any) => {
            this.click_to_call_loading = false;
            console.log(data);
            if(data.status){
                this.response_call_id = data.call_id;
                $("#click_to_call_progress").modal("show");
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endClicktoCall()
    {
        this.progression_msg = "";
        this.end_to_call_btn_disable = true;
        if(this.response_call_id)
        {
            let lead_id_arr = {'response_call_id': this.response_call_id};
            this.leadapi.endClicktoCall(lead_id_arr).subscribe((data:any) => {
                this.end_to_call_btn_disable = false;
                $('#click_to_call_progress').modal('hide');
            }, error => {
                this.sharedapi.checkError(error);
            });
        } else {
            this.sharedapi.checkError("Please reload the page. Something went to wrong.");
        }
        
    }

    async call_details(lead_id)
    {
        await this.leadapi.getIpdOpdCallDetails(lead_id).subscribe((data: any) => {
            if (data.status) {
                $("#ipd_call_details").modal("show");
              this.callDeatils = data.data;
            } else {
              this.callDeatils = [];
            }
          }, error => {
            this.sharedapi.checkError(error);
          });
    }

    closeCallDetailsModal(){
        $('#ipd_call_details').modal('hide');

    }

    copyMessage(text: string) {
        this.sharedapi.presentToast('Link copied to clipboard.');
        navigator.clipboard.writeText(text).then().catch(e => console.log(e));
    }

    showIPDAssignedToUpdateModal()
    {
        $('#myModalIPDAssignedtoUpdate').modal();
    }

    hideIPDAssignedToUpdateModal()
    {
        this.updatedPxAssignedToLeadId = "";
        this.notupdatedPxAssignedToLeadId = "";
        $('#myModalIPDAssignedtoUpdate').modal('hide');
    }

    async selectFileUpdatePxAssignedTo(event)
    {
        this.assigned_to_submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsvIPDPxAssignedTo(formData)
        .subscribe((data:any) => {
            this.assigned_to_submitted = false;
            this.csvUploadPxAssignedTeam.nativeElement.value = "";
            if(data.status)
            {
                this.updatedPxAssignedToLeadId = data.updatedLeadId;
                this.notupdatedPxAssignedToLeadId = data.notUpdatedLeadId;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }
    updateAssignee(userId: number, ipdId: number)
    {
        this.leadapi.updateIpdAssignee(userId, ipdId).subscribe((data:any) => {
            if(data.status) {
                this.sharedapi.presentToast(data.msg);
                this.loadIpds(this.pageIndex,this.perpage);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
  
    getFeedBackUser(status=1)
    {
        this.leadapi.getFeedbackUsers(status).subscribe((data:any) => {
            if(data.status)
            {
                this.feedBackUser = data.data;
            }else{
                this.feedBackUser = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
      async getMdSpok(md_source) {
        await this.leadapi.getMdSpokUsers(this.md_source).subscribe((response: any) => {
            console.log(response);
          if (response.status) {
            this.mdSpokData = response.data;
            this.mdSpokData_copy = this.mdSpokData;
          } else {
            this.mdSpokData = [];
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    
      }
      
      openPatientJourneyDialog(ipd_Id) {
        const dialogRef = this.dialog.open(PatientJourneyDetailsComponent, {
          width: '50%',
          height: '50%',
          data: ipd_Id
        });
      }


    exportPartnerDataList()
      {
        if(this.myrole=="1" || (this.myrole=="3" && this.is_presales_access=='1'))
        {
          if(this.ipds.length>0)
          {
            let data = [];
            let titles = ['Lead Id','Lead Status','Patient Name','Appointment Id','Glamyo Partner Id','Glamyo Appointment Id', 'Patient Age','Patient Gender','Lead Circle','IPD Circle','Lead Owner','Employee Id','Treatment',
             'Treatment Catergory','Mole/Lipoma Count','Doctor','Hospital','Room','Payment Mode','EMI Vendor Name','Lead Date','Surgery Date','Arrival Time','Treatment Time','Status','Created Date','Lead Source','Patient Mobile'];

              data.push(titles);

              for (let key in this.ipds) {
                  if(this.ipds[key].lead_source == 32){
                   let glamyoPatientId = 'GHIPD'+this.ipds[key].id;

                    let extData = [this.ipds[key].lead_id,this.ipds[key].leadStatus,this.ipds[key].patient,this.ipds[key].patient_id,this.ipds[key].glamyo_patient_id,glamyoPatientId,this.ipds[key].patient_age,this.ipds[key].gender,this.ipds[key].lead_circle_name,this.ipds[key].circle_name,this.ipds[key].bd_name,this.ipds[key].
                    useremployee_id,this.ipds[key].treatment_name,this.ipds[key].treatment_categoriesName,this.ipds[key].lmcCount,this.ipds[key].doctor_name,this.ipds[key].hospital_name,
                    this.getRoomCategory(this.ipds[key].room),
                    this.getPaymentType(this.ipds[key].payment_mode),
                    this.ipds[key].emi_vendor_name,
                    formatDate(this.ipds[key].leadCreatedTime*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),
                    formatDate(this.ipds[key].surgery_date*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),
                    formatDate(this.ipds[key].arrival_time*1000, 'hh:mm aa', 'en-US'),
                    formatDate(this.ipds[key].treatment_time*1000, 'hh:mm aa', 'en-US'),
                    this.sharedapi.getStatus(this.ipds[key].status),
                    formatDate(this.ipds[key].created_at*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),
                    this.sharedapi.getLeadSource(this.ipds[key].lead_source),
                    this.ipds[key].phone
                    ];


                    data.push(extData)
                }
               
              }

              let ws = XLSX.utils.aoa_to_sheet(data);
             /* generate workbook and add the worksheet */
             const wb: XLSX.WorkBook = XLSX.utils.book_new();
             XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
             /* save to file */
             let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
             XLSX.writeFile(wb, 'ipdPartnerData'+utc+'.xlsx');
          }else{
              this.sharedapi.presentToast('IPD not found!');
          }
        }
      }

  showModalGlamyoShares()
  {
      $('#myModalGlamyoShares').modal();
  }

  hideModalGlamyoShares()
  {
      $('#myModalGlamyoShares').modal('hide');
  }

  async selectFileIpdShare(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.leadapi.uploadIpdSharesCsv(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUploadShares.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalGlamyoShares();
              this.sharedapi.presentToast(data.msg);
              this.loadIpds(0, this.perpage);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

}
